import React, { useState } from "react";
import { Button, Modal, Select } from "antd";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import { Note } from "../../../components/Note";
import { API } from "../../../core/api";
import { useSelector } from "react-redux";
import { getCities } from "../../../core/utils";
import DeleteCity from "../DeleteCity/DeleteCity";
import CloseModalButton from "../../../components/CloseModalButton/CloseModalButton";
const AddCity = (props) => {
  const { isModalOpen, setIsModalOpen, data, getEmployees } = props;
  const { Option } = Select;

  const provinces = useSelector((state) => state.Store.provinces);
  const [state, setState] = useState({
    province_id: null,
    city_id: null,
  });
  const [cities, setCities] = useState([]);

  const setCityForEmployee = () => {
    if (!state.province_id) {
      return Note.error("Please select a province");
    }
    if (!state.city_id) {
      return Note.error("Please select a city");
    }

    // API.post
    //   .set_company_employee_cities({
    //     company_employee_id: data.pk,
    //     city_ids: [state.city_id].join(","),
    //     province_id: state.province_id,
    //   })
    //   .then((response) => {
    //     if (response.success) {
    //       setIsModalOpen(false);
    //       Note.success(response.message);
    //       getEmployees();
    //     } else {
    //       Note.error(response.message);
    //     }
    //   });
  };

  const handleChange = (data) => {
    setState({
      ...state,
      ...data,
    });
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={false}
      closable={true}
      title="Select City"
      closeIcon={
        <CloseModalButton isCloseIcon close={() => setIsModalOpen(false)} />
      }
    >
      <div className="flex-row flex-wrap pb-20 flex-content-space-between">
        <FormWrapper>
          <Select
            className="border-black-8"
            placeholder="Province"
            value={state.province_id}
            onChange={(value) => {
              handleChange({ province_id: value });
              getCities(value).then((response) => {
                if (response.success) {
                  setCities(response.data);
                } else {
                  Note.error(response.message);
                }
              });
            }}
          >
            {provinces.map((province) => {
              return (
                <Option key={province.id} value={province.id}>
                  {province.name}
                </Option>
              );
            })}
          </Select>
          <Select
            className="border-black-8"
            placeholder="City"
            value={state.city_id}
            onChange={(value) => handleChange({ city_id: value })}
          >
            {cities.map((city) => {
              return (
                <Option
                  key={city.id}
                  value={city.id}
                  onChange={(value) => setState({ city_id: value })}
                >
                  {city.name}
                </Option>
              );
            })}
          </Select>
          <div></div>
          <Button
            className="button-primary w-100 "
            onClick={setCityForEmployee}
          >
            Submit
          </Button>
        </FormWrapper>
      </div>
      {data?.cities?.length && (
        <DeleteCity data={data} getEmployees={getEmployees} />
      )}
    </Modal>
  );
};

export default AddCity;
